<template>
    <div>
        <div id="success_dialog" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered " role="document">
                <div class="modal-content">
                    <div class="modal-body d-flex flex-column align-items-center text-center px-5 py-4">

                        <div v-if="responseStatus == 1" class="d-flex flex-column">
                            <h3 class="pb-3" v-text="'Codul ' + code + ' este corect! '"></h3>
                            <p class="mb-0">Te-ai înscris în promoția SKOL și poți câștigă prin tragere la sorți unul
                                dintre premiile puse în joc</p>
                            <p>Păstrează capacul sau cheiță pentru validare! </p>
                            <p>Detalii în <a href="./Regulament.pdf" target="_blank">Regulamentul Oficial</a>.*</p>
                        </div>
                        <div v-else class="d-flex flex-column">
                            <h3 class="pb-2" v-text="responseTitle"></h3>
                            <p v-text="responseMessage"></p>
                        </div>

                        <div>
                            <!--                        <button data-dismiss="modal"-->
                            <!--                                @click="refresh">OK-->
                            <!--                        </button>-->
                            <!--                            <button data-dismiss="modal" @click="next">-->
                            <!--                                OK, acum mă răcoresc cu umor!-->
                            <!--                            </button>-->

                            <button data-dismiss="modal" data-toggle="modal" data-target="#redirect_modal">
                                OK
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div>

            <div id="redirect_modal" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered " role="document">
                    <div class="modal-content">
                        <div>
                            <button data-dismiss="modal" @click="refresh">
                                X
                            </button>
                        </div>
                        <div class="p-2 p-md-5" @click="next">
                            <img src="../assets/img/Group154.png" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>

    export default {
        name: "SuccessDialog",
        data() {
            return {
                code: null,
                response: null,
                responseTitle: null,
                responseMessage: null,
                responseStatus: null,
            }
        },
        mounted() {
            this.code = this.$store.getters.getCode;
            this.response = this.$store.getters.getResponse;

            if (this.response) {
                let message = this.response.message;
                message = message.replace(/([.?!])\s*(?=[A-Z])/g, "$1|").split("|");
                this.responseTitle = message[0];
                this.responseMessage = this.response.message.replace(this.responseTitle, '');
                this.responseStatus = this.response.status;
            }
        },
        methods: {
            refresh() {
                this.$emit('refresh');
            },

            next() {
                this.refresh();
                location.href = 'https://racorestebarbatul.ro/racorestetecuumor/';
            },

            onRefreshModal() {
                console.log('onRefreshModal');
                this.refresh();
            }
        }
    }
</script>

<style scoped>
    @font-face {
        font-family: 'HelveticaNeueCondensedBold';
        src: url('../assets/fonts/HelveticaNeue-CondensedBold.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-CondensedBold.woff') format('woff');
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueBold';
        src: url('../assets/fonts/HelveticaNeue-Bold.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-Bold.woff') format('woff');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueMedium';
        src: url('../assets/fonts/HelveticaNeue.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue.woff') format('woff');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueLight';
        src: url('../assets/fonts/HelveticaNeue-Light.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-Light.woff') format('woff');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    .modal-content {
        background-color: #FCCA33;
        border-radius: 46px;
        border: 0;
    }

    .modal-content h3, .modal-content p, .modal-content a {
        color: #205D3B;
        font-family: 'HelveticaNeueBold';
    }

    .modal-content a {
        text-decoration: underline;
    }

    #success_dialog button {
        color: #FCCA33;
        background-color: #205D3B;
        outline: 0;
        border: 0;
        padding: 10px 70px;
        font-size: 22px;
        text-transform: uppercase;
        border-radius: 30px;
        transition: all 0.2s linear;
        font-family: 'HelveticaNeueBold';
    }

    #success_dialog button:hover, #success_dialog button:active {
        color: white;
        transition: all 0.2s linear;
    }

    #redirect_modal .modal-content {
        background-image: url("../assets/img/bg_ncp.jpg");
        object-fit: cover;
        object-position: center;
        background-size: 100%;
        border-radius: 20px;
        background-repeat: no-repeat;
    }

    #redirect_modal .modal-content button {
        width: 30px;
        height: 30px;
        background-color: #E01635;
        outline: 0;
        border: 0;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        right: -6px;
        top: -5px;
        position: absolute;
    }
</style>
